import { render } from "./actionView.vue?vue&type=template&id=54c7bed2&scoped=true&ts=true"
import script from "./actionView.vue?vue&type=script&lang=ts&config=true"
export * from "./actionView.vue?vue&type=script&lang=ts&config=true"

import "./actionView.vue?vue&type=style&index=0&id=54c7bed2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c7bed2"]])

export default __exports__